import React from "react";
import InfoIcon from "../InfoIcon";
import { typography, surfaces, borders, textColors, interactive } from "../../../design-system/tokens";

export default function BooleanChoiceField({ label, help, value, onChange, trueLabel = "Yes", falseLabel = "No", infoText }) {
  const options = [
    { key: "false", label: falseLabel, bool: false },
    { key: "true", label: trueLabel, bool: true },
  ];

  return (
    <div className="field-wrapper">
      <div className="edit-field-row w-full flex items-center justify-between gap-3 py-1.5">
        {label && (
          <div className="min-w-0 flex-1">
            <div className={`${typography.label} ${textColors.secondary} flex items-center min-w-0`}>
              <span className="truncate select-none">{label}</span>
              {infoText ? <span className="ml-2 shrink-0"><InfoIcon text={infoText} /></span> : null}
            </div>
          </div>
        )}
        <div className={`inline-flex max-w-full shrink-0 rounded-xl border ${borders.default} overflow-hidden`}>
          {options.map((opt, idx) => {
            const selected = Boolean(value) === opt.bool;
            return (
              <button
                type="button"
                key={opt.key}
                onClick={() => onChange(opt.bool)}
                className={`px-5 py-2 focus:outline-none transition-colors ${typography.button} ${
                  selected
                    ? `${interactive.selectedBg} text-white shadow-sm`
                    : `${surfaces.primary} ${textColors.primary} ${surfaces.hover}`
                } ${idx === 0 ? `border-r ${borders.default}` : ""}`}
                aria-pressed={selected}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      </div>
      {help && <div className={`mt-2 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
}

// Back-compat for tests and callsites that import a named export.
export { BooleanChoiceField };
